<template>
    <div>

        <config-main-title>
            Envio de Mensagens para o Paciente
        </config-main-title>

        <template v-if="edicao_mensagem">

            <pre v-if="false">{{ edicao_mensagem }}</pre>

            <div class="alert alert-info d-flex justify-content-between">
                <div>
                    {{ edicao_mensagem.st_mensagem_tipo }}
                </div>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" 
                        :id="'so-mensagens-' + edicao_mensagem.id_mensagem_tipo" 
                        v-model="edicao_mensagem.fl_apenas_custom" 
                        @change="toggle_apenas_custom(edicao_mensagem)"
                    >
                    <label class="custom-control-label" :for="'so-mensagens-' + edicao_mensagem.id_mensagem_tipo">
                    Só usar mensagens customizadas
                    </label>
                </div>
                <div>
                    Mensagens Customizadas
                </div>
            </div>

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search_msg" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir_msg ()">
                        Incluir Mensagem
                    </button>
                </div>
            </div>

            <div v-if="( !lista_msg || !lista_msg.length )">
                <az-empty-state 
                    :msg="'Nenhuma mensagem identificada.'" 
                    icon="fa-solid fa-envelope-open-text"
                    :action="search_msg ? '' : 'Incluir Mensagem'" 
                    :method="search_msg ? null : incluir_msg" />
            </div>

            <div v-if="lista_msg && lista_msg.length">

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista_msg" :key="id">
                        <span>
                            <a href="#" @click.prevent="editar_msg(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle_msg(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <div v-else>
                                <span class="badge badge-secondary" v-if="dado.in_regra_ordem">{{ dado.in_regra_ordem }}</span>
                            </div>
                        </span>
                    </li>
                </div>

            </div>

            <button type="button" class="btn btn-secondary mt-3" @click="edicao_mensagem = null">Voltar</button>

        </template>

        <template v-else>

            <az-empty-state v-if="!dados" />

            <table class="table bg-white table-hover" v-if="dados">
                <thead>
                    <tr>
                        <td width="40%">
                            <small>Evento</small>
                        </td>
                        <td width="10%">
                            <i class="fas fa-share fa-2x text-dark"></i>
                            <div>
                                <small>Envio</small>
                            </div>
                        </td>
                        <td width="10%">
                            <i class="fas fa-rss fa-2x text-dark"></i>
                            <div>
                                <small>Todos os Canais</small>
                            </div>
                            <div>
                                <small class="text-muted">Ou o primeiro disponível</small>
                            </div>
                        </td>
                        <td width="10%">
                            <i class="fab fa-telegram-plane fa-2x text-info" aria-hidden="true"></i>
                            <div>
                                <small>Telegram</small>
                            </div>
                            <div>
                                <span class="badge badge-primary">free</span>
                            </div>
                        </td>
                        <td width="10%">
                            <i class="fab fa-whatsapp fa-2x text-success"></i>
                            <div>
                                <small>Whatsapp</small>
                            </div>
                            <div>
                                <span class="badge badge-secondary">{{servico_whatsapp}}</span>
                            </div>
                        </td>
                        <td width="10%">
                            <i class="fas fa-sms fa-2x text-success"></i>
                            <div>
                                <small>SMS</small>
                            </div>
                            <div>
                                <span class="badge badge-secondary">R$ 0,15</span>
                            </div>
                        </td>
                        <td width="10%">
                            <i class="far fa-envelope-open fa-2x text-primary"></i>
                            <div>
                                <small>e-mail</small>
                            </div>
                            <div>
                                <span class="badge badge-primary">free</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="table-info">
                        <td>
                            Disponível
                        </td>
                        <td>
                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                        </td>
                        <td>
                        </td>
                        <td>
                            <i class="fa fa-check text-success" aria-hidden="true"
                                v-if="$store.state.unidade.parametro_unidade.telegram_bot"></i>
                            <i class="fas fa-times text-danger" v-else></i>
                        </td>
                        <td>
                            <i class="fa fa-check text-success" aria-hidden="true"
                                v-if="$store.state.unidade.parametro_unidade.tem_whatsapp && servico_whatsapp != ''"></i>
                            <i class="fas fa-times text-danger" v-else></i>
                        </td>
                        <td>
                            <i class="fa fa-check text-success" aria-hidden="true"
                                v-if="1==0 && $store.state.unidade.parametro_unidade.tem_sms"></i>
                            <i class="fas fa-times text-danger" v-else></i>
                        </td>
                        <td>
                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                        </td>
                        <td class="text-center">
                            Filtros
                        </td>

                        <td>
                            Mensagem
                        </td>

                        <td class="text-nowrap">
                            Adiamento do Envio
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(dado, idx) in lista" :key="idx">
                        <td>
                            {{ dado.st_mensagem_tipo }}
                        </td>
                        <td>
                            <div class="custom-control custom-switch" v-if="dado.id_mensagem_tipo != 10">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'ativo-' + idx"
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + idx"></label>
                            </div>
                        </td>
                        <td>
                            <div class="custom-control custom-switch" v-if="dado.fl_ativo && ( dado.id_mensagem_tipo == 7 || dado.id_mensagem_tipo == 5 || dado.id_mensagem_tipo == 9 )">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'todos-' + idx"
                                    v-model="dado.fl_todos"
                                    @change="atualizar(dado)">
                                <label class="custom-control-label" :for="'todos-' + idx"></label>
                            </div>
                        </td>
                        <td>
                            <div class="custom-control custom-switch" v-if="dado.fl_ativo && dado.id_mensagem_tipo != 10 && dado.id_mensagem_tipo != 13 && dado.id_mensagem_tipo != 14 && $store.state.unidade.parametro_unidade.telegram_bot">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'telegram-' + idx"
                                    v-model="dado.fl_telegram"
                                    @change="atualizar(dado)">
                                <label class="custom-control-label" :for="'telegram-' + idx"></label>
                            </div>
                        </td>
                        <td>
                            <div class="custom-control custom-switch" v-if="(dado.id_mensagem_tipo == 2 || dado.id_mensagem_tipo == 4 || dado.id_mensagem_tipo == 5 || dado.id_mensagem_tipo == 7 || dado.id_mensagem_tipo == 8 || dado.id_mensagem_tipo == 9 || dado.id_mensagem_tipo == 11 || dado.id_mensagem_tipo == 12 || dado.id_mensagem_tipo == 14) && dado.fl_ativo && $store.state.unidade.parametro_unidade.tem_whatsapp && servico_whatsapp != ''">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'whatsapp-' + idx"
                                    v-model="dado.fl_whatsapp"
                                    @change="atualizar(dado)">
                                <label class="custom-control-label" :for="'whatsapp-' + idx"></label>
                            </div>
                        </td>
                        <td>
                            <div class="custom-control custom-switch" v-if="dado.id_mensagem_tipo == 4 && dado.fl_ativo && 1==0 && $store.state.unidade.parametro_unidade.tem_sms">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'sms-' + idx"
                                    v-model="dado.fl_sms"
                                    @change="atualizar(dado)">
                                <label class="custom-control-label" :for="'sms-' + idx"></label>
                            </div>
                        </td>
                        <td>
                            <div class="custom-control custom-switch" v-if="dado.fl_ativo && dado.id_mensagem_tipo != 10 && dado.id_mensagem_tipo != 14">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'email-' + idx"
                                    v-model="dado.fl_email"
                                    @change="atualizar(dado)">
                                <label class="custom-control-label" :for="'email-' + idx"></label>
                            </div>
                        </td>
                        <td class="text-nowrap">
                            <button type="button" class="btn btn-sm mr-1" 
                                :class="dado.filtros.length > 0 ? 'btn-outline-primary' : 'btn-outline-secondary'"
                                :disabled="dado.id_mensagem_tipo == 10 || dado.id_mensagem_tipo == 13"
                                @click="editar_filtros(dado)" v-if="dado.filtros">
                                <i class="fa fa-filter" aria-hidden="true"></i>
                                <span class="badge ml-1"
                                    :class="dado.filtros.length > 0 ? 'badge-primary' : 'badge-secondary'">{{ dado.filtros.length }}</span>
                            </button>
                            <az-audit-log-button sizing="sm" model="mensagemTipo" :id="dado.id_mensagem_tipo" />
                        </td>

                        <td>
                            <button type="button" class="btn btn-sm btn-block" 
                                v-if="dado.st_mensagem_customizada"
                                :class="dado.st_mensagem_customizada ? 'btn-outline-primary' : 'btn-outline-secondary'"
                                @click="editar_mensagem(dado)">
                                <i class="fa fa-envelope" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-block" 
                                v-else
                                :class="dado.customs_ativos_count ? 'btn-outline-primary' : 'btn-outline-secondary'"
                                @click="editar_mensagens(dado)">
                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.customs_ativos_count">
                                    {{ dado.customs_ativos_count }}
                                </span>
                            </button>
                        </td>

                        <td>
                            <!-- || dado.id_mensagem_tipo == 7 || dado.id_mensagem_tipo == 8  -->
                            <az-input
                                class="mb-0"
                                :mb="false"
                                v-if="dado.fl_ativo && ( dado.id_mensagem_tipo == 5 )"
                                sizing="sm"
                                type="number"
                                placeholder="Imediato..."
                                v-model="dado.in_delay_tempo_minuto">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2" v-if="dado.in_delay_tempo_minuto">min(s)</span>
                                        <az-submit color="outline-success" :hide_content_while_loading="true" title="Atualizar" @click="atualizar(dado)">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </az-submit>
                                    </div>
                                </template>
                            </az-input>
                        </td>
                    </tr>
                </tbody>
            </table>

            <pre v-if="1 == 0">{{ dados }}</pre>
            <az-audit-log-button v-if="1 == 0" />

            <!-- Modal -->
            <div class="modal fade" id="filtrosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content" v-if="item">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtros: {{ item.st_mensagem_tipo }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        </div>
                        <div class="modal-footer">
                            <az-audit-log-button model="mensagemTipo" :id="item.id_mensagem_tipo" v-if="item && item.id_mensagem_tipo" />
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atualizar(item, 'filtrosModal', true)">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="mensagemModal">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content" v-if="item">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                Mensagem Customizada
                                <span class="badge badge-secondary ml-2" v-if="item.st_mensagem_tipo">
                                    #{{ item.st_mensagem_tipo }}
                                </span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">

                            <template v-if="servico_whatsapp == 'WideChat' || servico_whatsapp =='Kualiz' || servico_whatsapp =='Escallo' || servico_whatsapp =='Ingenium' || servico_whatsapp =='EAS' || servico_whatsapp =='AuroraWhatsApp' || servico_whatsapp =='Cybertalk' || servico_whatsapp =='WhatsAppGenerico'">
                                <div class="form-row">

                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Nome do Template"
                                            v-model="item.st_template_name"
                                            placeholder="Nome do template..."
                                        />
                                    </div>

                                    <div class="col col-12 col-md-3" v-if="servico_whatsapp == 'Kualiz'">
                                        <az-input
                                            label="Id da Fila"
                                            v-model="item.st_channel"
                                            placeholder="Padrão..."
                                        />
                                    </div>

                                    <div class="col col-12 col-md-3" v-else-if="servico_whatsapp == 'WideChat'">
                                        <az-input
                                            label="Id do Canal"
                                            v-model="item.st_channel"
                                            placeholder="Canal..."
                                        />
                                    </div>
                                    
                                </div>
                            </template>

                            <template>
                                <az-input
                                    class="mt-2"
                                    label="Conteúdo"
                                    type="textarea"
                                    rows="8"
                                    required
                                    placeholder="Texto padrão..."
                                    v-model="item.st_mensagem_customizada" />
                            </template>

                            <template v-if="campos && campos.length">
                                <az-input
                                    sizing="sm"
                                    icon="fa fa-plus"
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="campos"
                                    optionsDisplay="search"
                                    v-model="novoCampo"
                                    @input="incluir_novo_campo()" />
                            </template>
                        
                            <div class="form-row mt-3">
                                <div class="d-flex col col-4 col-md-4">
                                    <div class="input-group mb-0">
                                        <input type="text" class="form form-control" placeholder="Número do Atendimento..." v-model="item.id_previa_atendimento"/>
                                        <div class="input-group-append">
                                            <button type="button" @click="visualizar(item)" :disabled="!item.id_previa_atendimento || !item.st_mensagem_customizada ? true : false" :class="item.id_previa_atendimento && item.st_mensagem_customizada ? 'btn btn-primary' : 'btn btn-secondary'">Visualizar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row mt-3" v-if="item.id_previa_atendimento && item.previa_mensagem">
                                <div class="col col-12 col-md-12">
                                    <div class="alert alert-secondary" style="white-space: pre-wrap;">{{ item.previa_mensagem }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer d-flex justify-content-between">
                            <div>
                            </div>
                            <div>
                                <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                                <az-submit @click="atualizar(item, 'mensagemModal', true)">Atualizar</az-submit>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

        </template>

        <!-- Edição da Mensagem Customizada -->
        <div class="modal fade" id="msgCustomModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="msg_custom">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensagem Customizada {{ msg_custom.id_mensagem_custom ? '#' + msg_custom.id_mensagem_custom : 'Nova' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Título"
                                    required
                                    :validate="validate"
                                    placeholder="Informe o Título da Mensagem..."
                                    v-model="msg_custom.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Ordem"
                                    required
                                    :validate="validate"
                                    type="number"
                                    placeholder="Ordem..."
                                    v-model="msg_custom.in_regra_ordem" />
                            </div>
                        </div>
                        
                        <template v-if=" servico_whatsapp == 'WideChat' || servico_whatsapp == 'Kualiz' || servico_whatsapp == 'Escallo' || servico_whatsapp =='Ingenium' || servico_whatsapp =='EAS' || servico_whatsapp =='AuroraWhatsApp' || servico_whatsapp =='Cybertalk' || servico_whatsapp =='WhatsAppGenerico'">
                            <div class="form-row">
                                
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Nome do Template"
                                        v-model="msg_custom.st_template_name"
                                        placeholder="Template..."
                                    />
                                </div>

                                <div class="col col-12 col-md-3" v-if="servico_whatsapp == 'Kualiz'">
                                    <az-input
                                        label="Id da Fila"
                                        v-model="msg_custom.st_channel"
                                        placeholder="Padrão..."
                                    />
                                </div>

                                <div class="col col-12 col-md-3" v-else-if="servico_whatsapp == 'WideChat'">
                                    <az-input
                                        label="Id do Canal"
                                        v-model="msg_custom.st_channel"
                                        placeholder="Canal..."
                                    />
                                </div>

                                <template v-if="servico_whatsapp == 'Kualiz' && msg_custom.id_mensagem_tipo == 12">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="NPS Score Inicial"
                                            type="number"
                                            v-model="msg_custom.js_params.nps_score_inicial"
                                            placeholder="0 a 10"
                                        />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="NPS Score Final"
                                            type="number"
                                            v-model="msg_custom.js_params.nps_score_final"
                                            placeholder="0 a 10"
                                        />
                                    </div>
                                </template>
                                
                            </div>
                        </template>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Sexo"
                                    type="select"
                                    placeholder="Qualquer..."
                                    optionsData="id"
                                    :optionsList="[
                                        { id: 'F', search: 'Feminino' },
                                        { id: 'M', search: 'Masculino' }
                                    ]"
                                    v-model="msg_custom.ch_sexo" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="De (Idade em Anos)"
                                    type="number"
                                    placeholde="De..."
                                    v-model="msg_custom.in_idade_min" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Até (Idade em Anos)"
                                    type="number"
                                    placeholde="Até..."
                                    v-model="msg_custom.in_idade_max" />
                            </div>
                        </div>

                        <az-input
                            sizing="sm"
                            class="my-2"
                            type="checkbox-group"
                            label="Ativo"
                            v-model="msg_custom.fl_ativo" />

                        <az-input
                            label="Conteúdo"
                            type="textarea"
                            rows="8"
                            required
                            :validate="validate"
                            placeholder="Informe o Texto da Mensagem..."
                            @input="previa.previa_mensagem = ''"
                            v-model="msg_custom.st_mensagem" />

                        <template v-if="campos && campos.length">
                            <az-input
                                sizing="sm"
                                icon="fa fa-plus"
                                type="select"
                                optionsMode="json"
                                :optionsList="campos"
                                optionsDisplay="search"
                                v-model="novoCampo"
                                @input="incluir_novo_campo(true)" />
                        </template>

                        <filtro-model class="my-3" v-model="msg_custom.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <template v-if="edicao_mensagem && edicao_mensagem.servico_whatsapp == 'Kualiz'">
                            <az-sub-title class="mt-3" title="Kualiz" />
                            <div class="row" v-if="msg_custom.js_params">
                                <div class="col col-12">
                                    <az-input
                                        label="Id da imagem na galeria do Kualiz"
                                        placeholder="Sem envio de imagem..."
                                        sizing="sm"
                                        icon="fa fa-image"
                                        v-model="msg_custom.js_params.whatsapp_imagem_id"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="msg_custom.js_params">
                                <div class="col col-12">
                                    <az-input
                                        label="Outra Configuração"
                                        placeholder="A mesma de outras configurações..."
                                        sizing="sm"
                                        icon="fa fa-gear"
                                        v-model="msg_custom.js_params.kualiz_outra_config"
                                    />
                                </div>
                            </div>
                        </template>

                        <az-sub-title class="mt-3" title="Teste de Visualização da Mensagem" />
                        <div class="form-row mt-3">
                            <div class="d-flex col col-4 col-md-4">
                                <div class="input-group mb-0">
                                    <input type="text" class="form form-control" placeholder="Número do Atendimento..." v-model="previa.id_previa_atendimento"/>
                                    <div class="input-group-append">
                                        <button type="button" @click="previa.st_mensagem_customizada = msg_custom.st_mensagem; visualizar(previa)" :disabled="!previa.id_previa_atendimento || !msg_custom.st_mensagem ? true : false" :class="previa.id_previa_atendimento && msg_custom.st_mensagem ? 'btn btn-primary' : 'btn btn-secondary'">Visualizar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row mt-3" v-if="previa.id_previa_atendimento && previa.previa_mensagem">
                            <div class="col col-12 col-md-12">
                                <div class="alert alert-secondary" style="white-space: pre-wrap;">{{ previa.previa_mensagem }}</div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="mensagemCustom" :id="msg_custom.id_mensagem_custom" v-if="msg_custom && msg_custom.id_mensagem_custom" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_msg()">{{ msg_custom.id_mensagem_custom ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    data () {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A",
            title: "",
            short_title: "",
            service: "",
            campos: [],
            novoCampo: '',
            previaMensagem: "",
            edicao_mensagem: null, 
            msg_custom: null, 
            previa: { 
                id_previa_atendimento: "",
                st_mensagem_customizada : "", 
                previa_mensagem: "", 
            },
            search_msg: "", 
        }
    },

    props: ['cadastro'],

    components: {
        ConfigMainTitle,
        AzEmptyState,
        AzAuditLogButton,
        FiltroModel, 
        AzSubmit,
        AzInput, 
        AzSubTitle, 
    },

    computed: {
        lista: function() {
            if ( !this.dados )
                return [];
            
            return this.dados.filter(item => item.id_mensagem_tipo != 6);
            
            /*
            this.dados = (this.dados.map(item => {
                item.previa_mensagem = ""
                item.id_previa_atendimento = null;
                return item;
            }));

            return this.dados;
            */

        },

        servico_whatsapp: function() {
            if ( !this.dados )
                return '';
            const item = _.first(this.dados);
            return ( item && item.servico_whatsapp ) ? item.servico_whatsapp : '';
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\apoiado', search:'Apoiado', service: 'apoiados.index'}, 
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\sinalizadorAtendimento', search:'Sinalizador de Atendimento', service: 'sinalizadores.index', parms: { ativos: 1 }},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            }
            
            return opcoes;
        },

        lista_msg: function () { 
            let pesquisar = this.search_msg.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return ( this.edicao_mensagem && this.edicao_mensagem.customs && this.edicao_mensagem.customs.length ) ? 
                this.edicao_mensagem.customs.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search_msg || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: {
        editar_msg (item) { 
        
            this.previa.previa_mensagem = '';
            this.validate = false;

            if ( this.edicao_mensagem && this.edicao_mensagem.servico_whatsapp == 'Kualiz' ) { 
                if ( !item.js_params ) { 
                    item.js_params = { whatsapp_imagem_id: "" };
                }
            }

            this.msg_custom = _.cloneDeep(item);

            $('#msgCustomModal').modal('show');

        },

        incluir_msg () { 

            this.previa.previa_mensagem = '';
            this.validate = false;

            this.msg_custom = { 
                id_mensagem_tipo: this.edicao_mensagem.id_mensagem_tipo,
                st_titulo: "", 
                fl_ativo: true, 
                in_regra_ordem: 100, 
                st_mensagem: "", 
                filtros: [],
                st_template_name: "",
                st_channel: "",
                js_params: { whatsapp_imagem_id: "" }, 
            };

            $('#msgCustomModal').modal('show');

        },

        atualizar_msg () { 

            this.$util.atualizar(this, {
                service: 'mensagens_custom',
                dados: this.msg_custom,
                toast: true, 
                modal: 'msgCustomModal',
                callback: () => { 
                    this.editar_mensagens(this.edicao_mensagem);
                }
            });

        },

        editar_mensagens(item) { 
            this.$util.load(this, { 
                service: 'mensagens_tipo',
                func: 'show',
                parms: { 
                    id: item.id_mensagem_tipo, 
                    cadastro: true, 
                    custom: true, 
                },
                loadTo: res => { 
                    this.edicao_mensagem = res;        
                }
            });
        },

        editar_filtros(item) { 
            this.item = _.cloneDeep(item);

            $('#filtrosModal').modal('show');
        },

        load () {
            this.$util.load(this, {
                service:'mensagens_tipo',
                func: 'index',
                parms: {
                    cadastro: true,
                },
            });
        },

        atualizar (item, modal, reload = false) {

            this.$util.atualizar(this, {
                service: 'mensagens_tipo',
                dados: item,
                reload: reload,
                modal: modal,
            });

        },

        visualizar(item) {

            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'mensagem_tipo.previa_mensagem',
                    id: 'previa',
                    parms: {
                        'id_previa_atendimento': item.id_previa_atendimento,
                        'texto': item.st_mensagem_customizada
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if(res.data.previa.status == 200) {
                        if(_.get(res.data, 'previa.data')) {
                            item.previa_mensagem = res.data.previa.data;
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "Atendimento Não Encontrado.",
                                life: 5000
                            });
                        } 
                    }
                }).finally(() => {
                    this.$store.commit('loading', false);
                })

        },

        toggle_msg (item) {

            this.$util.toggle(this, {
                service: 'mensagens_custom',
                dados: item,
            });

        },

        toggle (item) {

            this.$util.toggle(this, {
                service: 'mensagens_tipo',
                dados: item,
            });

        },

        toggle_apenas_custom (item) {
            console.log('toggle_apenas_custom', item);

            this.$util.atualizar(this, {
                service: 'mensagem_tipo',
                func: 'toggle_apenas_custom',
                dados: {
                    id_mensagem_tipo: item.id_mensagem_tipo,
                }
            });

        },

        editar_mensagem (item) {
            this.item = null;

            this.$nextTick(() => { 
                let edicao = _.cloneDeep(item); 

                edicao.previa_mensagem = ""
                edicao.id_previa_atendimento = null;
            
                this.item = _.cloneDeep(edicao);
                $('#mensagemModal').modal('show');
            });
        },
        
        incluir_novo_campo(custom = false) {
            if ( !this.novoCampo )
                return;

            if ( custom ) { 

                const mensagem = this.msg_custom.st_mensagem ? this.msg_custom.st_mensagem : '';

                this.msg_custom.st_mensagem = mensagem + ' #' + _.get(this.novoCampo, 'search');

            } else { 

                const mensagem = this.item.st_mensagem_customizada ? this.item.st_mensagem_customizada : '';

                this.item.st_mensagem_customizada = mensagem + ' #' + _.get(this.novoCampo, 'search');

            }

            this.novoCampo = null;

            this.$nextTick(() => {
                this.novoCampo = "";
            });

        }
        
    },

    mounted () {
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Envio de Mensagem", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, {
            service: 'etiquetas',
            func: 'campos',
            parms: {
                model: 'atendimento'
            }
        })
        .then(res => {
            this.campos = res;
        });

    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
